/* Orka Nordic – minimal vanilla JS (countdown, sliders, gallery, bundles, add-to-cart, sticky bar) */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const fmt = (cents) => { const c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ISK'; const d = c === 'ISK' ? 0 : 2; try { return new Intl.NumberFormat('is-IS', { style: 'currency', currency: c, minimumFractionDigits: d, maximumFractionDigits: d }).format((Math.round(Number(cents) || 0)) / 100); } catch (e) { return String(Math.round((Number(cents) || 0) / 100)); } };

/* ---------- countdown ---------- */
function initCountdowns(root = document) {
  $$('[data-jf-countdown]', root).forEach((el) => {
    if (el._jf) return; el._jf = true;
    const raw = (el.dataset.end || '').trim();
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/);
    const off = parseFloat(el.dataset.offset || '0');
    const end = m ? Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - off * 3600000 : NaN;
    const bar = el.closest('.jf-ann') || el;
    const set = (k, v) => { const n = $(`[data-u="${k}"]`, el); if (n) n.textContent = String(v).padStart(2, '0'); };
    const tick = () => {
      const d = end - Date.now();
      if (!(d > 0)) { bar.classList.add('is-ended'); const t = $('[data-jf-ended]', bar); if (t) { t.hidden = false; } $$('[data-jf-live]', bar).forEach(x => x.hidden = true); return false; }
      const s = Math.floor(d / 1000);
      set('d', Math.floor(s / 86400)); set('h', Math.floor((s % 86400) / 3600)); set('m', Math.floor((s % 3600) / 60)); set('s', s % 60);
      return true;
    };
    if (tick()) el._t = setInterval(() => { if (!tick()) clearInterval(el._t); }, 1000);
  });
}

/* ---------- sliders ---------- */
function initSliders(root = document) {
  $$('[data-jf-slider]', root).forEach((sl) => {
    if (sl._jf) return; sl._jf = true;
    const track = $('[data-jf-track]', sl) || $('.jf-track', sl);
    if (!track) return;
    const slides = () => Array.from(track.children);
    const prev = $$('[data-jf-prev]', sl), next = $$('[data-jf-next]', sl);
    const dotsWrap = $('[data-jf-dots]', sl);
    const step = () => { const s = slides(); if (s.length < 2) return track.clientWidth; return s[1].getBoundingClientRect().left - s[0].getBoundingClientRect().left; };
    const pages = () => { const st = step() || 1; return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / st) + 1); };
    const cur = () => Math.round(track.scrollLeft / (step() || 1));
    const go = (i) => { track.scrollTo({ left: i * step(), behavior: 'smooth' }); };
    prev.forEach(b => b.addEventListener('click', () => go(Math.max(0, cur() - 1))));
    next.forEach(b => b.addEventListener('click', () => { const c = cur(); go(c + 1 >= pages() ? (sl.dataset.loop ? 0 : c) : c + 1); }));
    const build = () => {
      if (!dotsWrap) return; const n = pages(); dotsWrap.innerHTML = '';
      if (n < 2) { dotsWrap.style.display = 'none'; return; } dotsWrap.style.display = '';
      for (let i = 0; i < n; i++) { const d = document.createElement('button'); d.type = 'button'; d.className = 'jf-dot'; d.setAttribute('aria-label', `${i + 1} / ${n}`); d.addEventListener('click', () => go(i)); dotsWrap.appendChild(d); }
      upd();
    };
    const upd = () => {
      const c = cur(), n = pages();
      if (dotsWrap) $$('.jf-dot', dotsWrap).forEach((d, i) => d.classList.toggle('is-active', i === Math.min(c, n - 1)));
      const atStart = track.scrollLeft < 4, atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prev.forEach(b => b.disabled = atStart && !sl.dataset.loop);
      next.forEach(b => b.disabled = atEnd && !sl.dataset.loop);
      sl.dispatchEvent(new CustomEvent('jf:slide', { detail: { index: c } }));
    };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    new ResizeObserver(() => build()).observe(track);
    build();
    sl._go = go;
  });
}

/* ---------- product gallery ---------- */
function initGallery(root = document) {
  $$('[data-jf-gallery]', root).forEach((g) => {
    if (g._jf) return; g._jf = true;
    const track = $('[data-jf-track]', g), thumbs = $$('[data-jf-thumb]', g), count = $('[data-jf-count]', g);
    const w = () => track.clientWidth || 1;
    const idx = () => Math.round(track.scrollLeft / w());
    const go = (i) => track.scrollTo({ left: i * w(), behavior: 'smooth' });
    const n = track.children.length;
    $$('[data-jf-gprev]', g).forEach(b => b.addEventListener('click', () => go((idx() - 1 + n) % n)));
    $$('[data-jf-gnext]', g).forEach(b => b.addEventListener('click', () => go((idx() + 1) % n)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const upd = () => { const i = idx(); thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); }); const a = thumbs[i]; if (a) { const p = a.parentElement; const l = a.offsetLeft - p.clientWidth / 2 + a.clientWidth / 2; p.scrollTo({ left: l, behavior: 'smooth' }); } if (count) count.textContent = `${i + 1} / ${n}`; };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(Math.min(n - 1, idx() + 1)); if (e.key === 'ArrowLeft') go(Math.max(0, idx() - 1)); });
    upd();
  });
}

/* ---------- add to cart (integrates with Horizon cart drawer + bubble) ---------- */
let EventsMod = null;
async function events() { if (EventsMod !== null) return EventsMod; try { EventsMod = await import('@shopify/events'); } catch (e) { EventsMod = false; } return EventsMod; }
export async function jfAddToCart(variantId, quantity = 1, source) {
  const ev = await events();
  const sectionIds = $$('cart-items-component').map(e => e.dataset.sectionId).filter(Boolean);
  let deferred = null;
  if (ev && ev.CartLinesUpdateEvent) {
    deferred = ev.CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity }], promise: deferred.promise }));
  }
  const fd = new FormData();
  fd.append('id', variantId); fd.append('quantity', quantity);
  if (sectionIds.length) { fd.append('sections', sectionIds.join(',')); fd.append('sections_url', location.pathname); }
  const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  try {
    const res = await fetch(url, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    const data = await res.json();
    const cart = await (await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    if (data.status) {
      deferred && deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'orka', itemCount: quantity } });
      throw new Error(data.description || data.message || 'Villa');
    }
    if (deferred) deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'orka', sourceId: 'orka', itemCount: quantity, sections: data.sections, didError: false } });
    // fallback bubble update if Horizon components missing
    $$('[data-jf-cart-count]').forEach(n => n.textContent = cart.item_count);
    if (!$('cart-drawer-component') && !ev) location.href = '/cart';
    return cart;
  } catch (e) {
    deferred && deferred.reject && deferred.reject(e);
    throw e;
  }
}
window.jfAddToCart = jfAddToCart;

function bindAtc(btn, getVariant) {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    const v = getVariant(); if (!v) return;
    const err = btn.parentElement && $('[data-jf-err]', btn.parentElement.closest('[data-jf-product]') || document);
    btn.classList.add('is-loading'); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try { await jfAddToCart(v, 1, btn); btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1600); if (err) err.hidden = true; }
    catch (x) { if (err) { err.textContent = x.message || 'Ekki tókst að setja vöruna í körfuna. Reyndu aftur.'; err.hidden = false; } }
    finally { btn.classList.remove('is-loading'); btn.disabled = false; btn.removeAttribute('aria-busy'); }
  });
}

/* ---------- product page ---------- */
function initProduct(root = document) {
  $$('[data-jf-product]', root).forEach((pm) => {
    if (pm._jf) return; pm._jf = true;
    let variants = [];
    try { variants = JSON.parse($('[data-jf-variants]', pm).textContent); } catch (e) {}
    const radios = $$('[data-jf-radio]', pm);
    const atc = $('[data-jf-atc]', pm);
    const sticky = $('[data-jf-sticky]');
    const stSel = sticky && $('select', sticky);
    const state = { id: (radios.find(r => r.checked) || radios[0] || {}).value };
    const byId = (id) => variants.find(v => String(v.id) === String(id));
    const render = (push) => {
      const v = byId(state.id); if (!v) return;
      $$('[data-jf-price]').forEach(n => n.textContent = v.price_f || fmt(v.price));
      $$('[data-jf-compare]').forEach(n => { n.textContent = v.compare_at_price > v.price ? (v.compare_f || fmt(v.compare_at_price)) : ''; n.hidden = !(v.compare_at_price > v.price); });
      $$('[data-jf-save]').forEach(n => { const p = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0; n.textContent = (n.dataset.prefix || '') + p + '%'; n.hidden = !p; });
      $$('[data-jf-vtitle]').forEach(n => n.textContent = v.title);
      radios.forEach(r => r.closest('.jf-bc') && r.closest('.jf-bc').classList.toggle('is-checked', r.checked));
      if (stSel) stSel.value = String(v.id);
      // sticky / selected bundle image
      const imgUrl = v.image || (radios.find(r => String(r.value) === String(v.id)) || {}).dataset?.jfImg;
      if (imgUrl) {
        const stickyImg = sticky && (sticky.querySelector('[data-jf-sticky-img]') || sticky.querySelector('.jf-sticky__img'));
        if (stickyImg) { stickyImg.src = imgUrl; stickyImg.srcset = ''; stickyImg.removeAttribute('srcset'); }
      }
      if (atc) atc.disabled = !v.available;
      $$('[data-jf-avail]').forEach(n => n.textContent = v.available ? '' : 'Uppselt');
      if (push) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    };
    radios.forEach(r => r.addEventListener('change', () => { if (r.checked) { state.id = r.value; render(true); } }));
    if (stSel) stSel.addEventListener('change', () => { state.id = stSel.value; const r = radios.find(x => x.value === stSel.value); if (r) r.checked = true; render(true); });
    if (atc) bindAtc(atc, () => state.id);
    if (sticky) {
      const sbtn = $('[data-jf-sticky-atc]', sticky); if (sbtn) bindAtc(sbtn, () => state.id);
      let tick = false;
      const upd = () => { tick = false; if (!atc) return; const past = atc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        sbtn && (sbtn.tabIndex = past ? 0 : -1); };
      const onScroll = () => { if (!tick) { tick = true; requestAnimationFrame(upd); } };
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      upd();
    }
    const bar = $('[data-jf-soldbar]', pm);
    if (bar) { const io2 = new IntersectionObserver((e) => { if (e[0].isIntersecting) { bar.style.width = bar.dataset.w + '%'; io2.disconnect(); } }); io2.observe(bar); }
    render();
  });
  // second bundle section: direct add buttons
  $$('[data-jf-add]', root).forEach((b) => { if (b._jf) return; b._jf = true; bindAtc(b, () => b.dataset.jfAdd); });
  $$('a.jf-btn[href="#"]', root).forEach((a) => a.setAttribute('data-jf-select-scroll', ''));
  $$('[data-jf-select-scroll]', root).forEach((a) => { if (a._jf) return; a._jf = true; a.addEventListener('click', (e) => { const t = document.querySelector('[data-jf-product]'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }); });
}

/* ---------- newsletter (footer) ---------- */
function initVideos(root = document) {
  $$('[data-jf-video]', root).forEach((b) => {
    if (b._jf) return; b._jf = true;
    b.addEventListener('click', () => {
      const src = b.dataset.src; if (!src) return;
      const v = document.createElement('video'); v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
      b.replaceChildren(v);
    });
  });
}

function initAll(root = document) { initCountdowns(root); initSliders(root); initGallery(root); initProduct(root); initVideos(root); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));

/* ---------- cart: one-click upgrade to the 3+2 bundle (free shipping) ---------- */
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-jf-upgrade]'); if (!b) return;
  e.preventDefault(); if (b.disabled) return;
  const target = String(b.dataset.jfUpgrade); b.disabled = true; b.classList.add('is-loading');
  try {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    const prod = cart.items.filter(i => String(i.variant_id) !== target && cart.items.some(t => String(t.variant_id) === target && t.product_id === i.product_id));
    if (prod.length) {
      const updates = {}; prod.forEach(i => { updates[i.key] = 0; });
      await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    }
    await jfAddToCart(target, 1, b);
    if (document.body.classList.contains('template-cart') || location.pathname.endsWith('/cart')) location.reload();
  } catch (x) { b.disabled = false; }
  finally { b.classList.remove('is-loading'); }
});

/* ---------- Shopify cookie banner: Icelandic texts (banner text is not translatable for 'is' in admin) ---------- */
(() => {
  const M = {
    'Cookie consent': 'Vafrakökur',
    'Privacy Policy': 'persónuverndarstefna',
    'Manage preferences': 'Stillingar',
    'Accept': 'Samþykkja', 'Decline': 'Hafna',
    'Cookie and privacy preferences': 'Stillingar fyrir vafrakökur og persónuvernd',
    'Accept all': 'Samþykkja allt', 'Decline all': 'Hafna öllu', 'Save my choices': 'Vista val mitt',
    'You control your data': 'Þú stjórnar þínum gögnum',
    'Learn more about the cookies we use, and choose which cookies to allow.': 'Kynntu þér vafrakökurnar sem við notum og veldu hverjar þú leyfir.',
    'Required': 'Nauðsynlegar', 'Personalization': 'Sérsnið', 'Marketing': 'Markaðssetning', 'Analytics': 'Greining',
    'These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.': 'Þessar vafrakökur eru nauðsynlegar til að vefurinn virki rétt, t.d. við innskráningu og þegar vörur eru settar í körfu.',
    'These cookies store details about your actions to personalize your next visit to the website.': 'Þessar vafrakökur geyma upplýsingar um aðgerðir þínar til að sérsníða næstu heimsókn.',
    'These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.': 'Við og samstarfsaðilar okkar, þ.m.t. Shopify, notum þessar vafrakökur til að bæta markaðssamskipti og birta þér auglýsingar á öðrum vefsíðum.',
    'These cookies help us understand how you interact with the site. We use this data to identify areas to improve.': 'Þessar vafrakökur hjálpa okkur að skilja hvernig þú notar vefinn svo við getum bætt hann.',
    'Close dialog': 'Loka glugga'
  };
  const LEAD = "Við og samstarfsaðilar okkar, þ.m.t. Shopify, notum vafrakökur og aðra tækni til að sérsníða upplifun þína, birta auglýsingar og greina umferð. Við notum nauðsynlegar vafrakökur ásamt vafrakökum fyrir sérsnið, markaðssetningu og greiningu. Þú getur breytt stillingunum hvenær sem er.";
  const tr = (root) => {
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT); let n;
    while ((n = w.nextNode())) {
      const t = n.textContent.trim(); if (!t) continue;
      if (M[t]) n.textContent = n.textContent.replace(t, M[t]);
      else if (t.startsWith('We and our partners')) n.textContent = LEAD;
    }
    root.querySelectorAll('[aria-label]').forEach((e) => { const v = e.getAttribute('aria-label'); if (M[v]) e.setAttribute('aria-label', M[v]); });
  };
  const run = () => ['shopify-pc__banner', 'shopify-pc__prefs'].forEach((id) => { const el = document.getElementById(id); if (el) tr(el); });
  const idOf = (e) => (e && e.getAttribute && e.getAttribute('id')) || '';
  const rel = (m) => { const t = m.target; return idOf(t).startsWith('shopify-pc') || (t.closest && t.closest('[id^="shopify-pc__"]')) || [...m.addedNodes].some((a) => a.nodeType === 1 && (idOf(a).startsWith('shopify-pc') || (a.querySelector && a.querySelector('[id^="shopify-pc__"]')))); };
  const mo = new MutationObserver((ms) => { if (ms.some(rel)) run(); });
  const start = () => { run(); mo.observe(document.body, { childList: true, subtree: true }); };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
